import React from "react";
import Alert from "../../components/ui/Alerts/index";
import Image from "../../components/Forms/FormElements/Image/index";
import FormComponent from "../../components/Forms/index";
import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb";
const Home = () => {
  return (
    <>
      <Breadcrumb />
      <div className="px-[4px] lg:px-[16px]">
        <Alert value="Sorularınız tek dersten ve birden fazla konudan oluşacaktır." />
      </div>
      <div className="w-[100%] flex rounded-b-[12px] px-[4px] lg:px-[16px]">
        <Image />
        <div className="w-[100%] bg-white lg:ml-[16px]  rounded-[12px]">
          <FormComponent />
        </div>
      </div>
    </>
  );
};

export default Home;
